import { Employee } from '../types';

export const normalizeEmail = (email: string): string => email.trim().toLowerCase();

export const hasDuplicateEmployeeEmail = (
  employees: Employee[],
  email: string,
  excludeEmployeeId?: string,
): boolean => {
  const normalized = normalizeEmail(email);
  if (!normalized) return false;

  return employees.some((employee) => {
    if (excludeEmployeeId && employee.id === excludeEmployeeId) {
      return false;
    }
    return normalizeEmail(employee.email || '') === normalized;
  });
};
